import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["disabled"]

import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'epinio',
  props: {
    name: {}
  },
  setup(__props: any) {

const store = useStore();
const loading = ref<boolean>(true);
let redirectOpts = ref<object>({});
const t = store.getters['i18n/t'];

const props = __props;

onMounted(async () => {
  /* Fetch the dex redirect url.
  *
  * The dashboard would normally get this directly from the auth provider,
  * however epinio/dex implement pkce flow (additional per request validation).
  * To support this the redirect url is per request and thus generated by the
  * BE per login. Unfortunately this process also requires the state to be
  * known up front, so for this provider we create it upfront and pass through
  * to the auth store. */
  const baseNonce = await store.dispatch(
    'auth/createNonce',
    { provider: 'epinio' },
  );
  const encodedNonce = await store.dispatch('auth/encodeNonce', baseNonce);
  const res = await store.dispatch(
    'management/request',
    { url: `/dex/redirectUrl?state=${ encodedNonce }` },
  );

  const redirectAsUrl = new URL(res.redirectUrl);
  // We'll need to save this locally for when we exchange the code for a token
  const pkceCodeVerifier = redirectAsUrl.searchParams.get('code_verifier');

  // The scopes in the redirect url are pulled out and reapplied, however this
  // does not work for dex (a decoded space separator).
  const scopes = redirectAsUrl.searchParams.get(`scope`); // This decodes it

  // redirectTo mangles the different scopes together incorrectly, and we're
  // supply our own mangled version anyway, so nuke.
  redirectAsUrl.searchParams.delete('scope');

  redirectOpts.value = {
    provider: props.name,
    redirectUrl: redirectAsUrl.toString(),
    scopes: scopes.split(' '), // Put it in the format expcted by the `redirectTo` action
    scopesJoinChar: ' ',
    nonce: baseNonce,
    persistNonce: {
      ...baseNonce,
      pkceCodeVerifier
    }
  };

  loading.value = false;
});

function login() {
  store.dispatch('auth/redirectTo', redirectOpts.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref: "btn",
      class: "btn bg-primary",
      style: {"font-size":"18px"},
      disabled: loading.value,
      onClick: login
    }, _toDisplayString(_unref(t)('epinio.login.genericProvider')), 9, _hoisted_2)
  ]))
}
}

})